// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".leaflet-marker-icon .button[data-v-18318d7e]{position:relative}.leaflet-marker-icon .button[data-v-18318d7e]:after{background:var(--primary);bottom:-5px;content:\"\";display:block;height:10px;position:absolute;transform:rotate(45deg);width:10px}.leaflet-popup-content[data-v-18318d7e]{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
